export default function CheckoutRecoveryBanner({
  title = "Finish linking your subscription",
  description,
  busy = false,
  error = null,
  onRetry,
  retryLabel = "Try again",
  className = "",
}) {
  return (
    <section
      className={`rounded-2xl border border-amber-500/35 bg-amber-500/10 p-4 ${className}`}
    >
      <p className="text-sm font-semibold text-hc-text">{title}</p>
      <p className="mt-1 text-xs leading-5 text-hc-text-dim">
        {description}
        {busy ? " Linking now…" : " If this doesn't update shortly, try again below."}
      </p>
      {error && (
        <p className="mt-2 text-xs text-hc-error break-words">{error}</p>
      )}
      <button
        type="button"
        disabled={busy}
        onClick={onRetry}
        className="mt-3 rounded-[10px] bg-hc-primary px-4 py-2 text-xs font-semibold text-white hover:opacity-90 disabled:opacity-50"
      >
        {busy ? "Linking…" : retryLabel}
      </button>
    </section>
  );
}
